<template>
  <div class="calico-result-view">
    <header class="view-header">
      <h1 class="title--large">
        AI Results
      </h1>
    </header>
  
    <main class="result-container">
      <CalicoResult 
        :message="exampleData.message" 
        :content="exampleData.content"
      />
  
      <CalicoResult 
        :message="secondExample.message" 
        :content="secondExample.content"
      />
    </main>
  </div>
</template>
  
  <script>
  import CalicoResult from '@/components/pattern/result/index.vue';
  
  export default {
    name: 'CalicoResultView',
    components: {
      CalicoResult
    },
    data() {
      return {
        exampleData: {
          message: "BetaScore AI",
          content: "This is a predictive analysis based on your data. The approval probability is 85%"
        },
        secondExample: {
          message: "BetaScore AI",
          content: "Recommendation: Improve your credit score by paying your pending debts."
        }
      };
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .calico-result-view {
    @include stack-space($space-xxlarge);
    max-width: 800px;
    margin: 0 auto;
    padding: $space-large;
  
    .view-header {
      @include stack-space($space-medium);
      text-align: center;
      border-bottom: 1px solid $color-neutral-light;
      padding-bottom: $space-large;
    }
  
    .result-container {
      @include stack-space($space-xxlarge);
      justify-content: center;
      
    }
  }
  </style>